/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  Button,
  Typography,
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from '@mui/material';
import { useDispatch } from 'react-redux';
// import { addSnackbar } from '../../../redux/reducers/ducks/SnackbarDuck';

import {
  addSupplierApi,
  deleteSupplierApi
} from '../../api/suppliers/supplierApi';
import { addSnackbar } from '../../redux/reducers/ducks/SnackbarDuck';

const AddEditSupplier = ({
  addSupplierPopup,
  setAddSupplierPopup,
  callFunc
}) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm({
    defaultValues: {}
  });

  useEffect(() => {
    if (addSupplierPopup.id) {
      reset();
    }
  }, [addSupplierPopup.isOpen]);

  const onSubmit = async (data) => {
    const res = await addSupplierApi(data);
    if (res.status == 200) {
      dispatch(
        addSnackbar({
          message: 'New Menu Category Created',
          type: 'success'
        })
      );
      handleClose();
      callFunc();
    }
  };

  const handleClose = () => {
    setAddSupplierPopup({ isOpen: false });
    reset();
  };

  return (
    <Box>
      <Container>
        <Dialog open={addSupplierPopup.isOpen} onClose={handleClose}>
          <Box
            sx={{
              textAlign: 'center',
              width: 'min(100% -30px, 700px)',
              marginInline: 'auto'
            }}>
            <DialogTitle id="alert-dialog-title">
              {addSupplierPopup.id ? (
                <Typography color="#FFA500" fontWeight="700">
                  Delete Supplier
                </Typography>
              ) : (
                <Typography color="#FFA500" fontWeight="700">
                  Add New Supplier
                </Typography>
              )}
            </DialogTitle>
            {!addSupplierPopup.id ? (
              <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    {...register('name', { required: true })}
                    margin="normal"
                    label="Supplier Name"
                    fullWidth
                    error={Boolean(errors.password)}
                    helperText={errors.password ? 'Name is required' : ''}
                  />

                  <TextField
                    {...register('contact')}
                    margin="normal"
                    label="Supplier Contact"
                    fullWidth
                  />
                  <TextField
                    {...register('email')}
                    margin="normal"
                    label="Supplier Email"
                    fullWidth
                  />

                  <TextField
                    {...register('address')}
                    margin="normal"
                    label="Supplier Address"
                    fullWidth
                  />

                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                </form>
              </DialogContent>
            ) : (
              <>
                <DialogContent>
                  Are you sure to delete this supplier?
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} autoFocus>
                    cancel
                  </Button>
                  <Button
                    onClick={async () => {
                      const res = await deleteSupplierApi(addSupplierPopup?.id);
                      if (res.status == 200) {
                        dispatch(
                          addSnackbar({
                            message: 'Deleted',
                            type: 'warning'
                          })
                        );
                        handleClose();
                        callFunc();
                      }
                    }}>
                    Delete
                  </Button>
                </DialogActions>
              </>
            )}
          </Box>
        </Dialog>
      </Container>
    </Box>
  );
};

export default AddEditSupplier;
